import {
  grayColor,
  container,
  title,
  contentsSubTitle
} from "assets/jss/trip-kit.js";

import imagesStyles from "assets/jss/trip-kit/imagesStyles.js";

const sectionTextStyle = {
  container,
  title,
  contentsSubTitle,
  section: {
    paddingBottom: "0",
    backgroundPosition: "50%",
    backgroundSize: "cover",
    padding: "10px 0",
    "& p": {
      fontSize: "15px",
      "@media (min-width: 576px)": {
        fontSize: "15px"
      },
      "@media (min-width: 768px)": {
        fontSize: "15px"
      },
      "@media (min-width: 992px)": {
        fontSize: "16px"
      },
      "@media (min-width: 1200px)": {
        fontSize: "16px"
      },
     
      lineHeight: "1.5em",
      color: grayColor[15],
      marginBottom: "30px"
    },
    paddingLeft:"10px",
    paddingRight:"10px"
  },
  quoteText: {
    fontSize: "15px!important"
  },
  ...imagesStyles
};

export default sectionTextStyle;
